module.exports = __webpack_public_path__ + "static/mieszkania-puck-a76bccda23e689f40504499463393c74.jpg";